export const AJAX_TYPE = Object.freeze({
    GET: 'get',
    POST: 'post',
    DELETE: 'delete',
    PUT: 'put'
});